import * as ActionType from "./admin.type";
import jwt_decode from "jwt-decode";
import { clearAuthToken, setAuthToken } from "../../../util/authToken";

const initialState = {
  admin: {},
  isAuth: false,
  loading: false,
  error: null,
};



export const adminReducer = (state = initialState, action) => {
  let decode;
  switch (action.type) {
    case ActionType.LOGIN_ADMIN:

      if (action.payload) {
        decode = jwt_decode(action.payload);
      }
      // Set Token In Session
      setAuthToken(action?.payload);
      sessionStorage.setItem("isAuth", true);
      return {
        ...state,
        admin: decode,
        isAuth: true,
      };
    case ActionType.LOGOUT_ADMIN:
      clearAuthToken();
      sessionStorage.removeItem("isAuth");
      sessionStorage.removeItem("key");
      return {
        ...state,
        admin: {},
        isAuth: false,
      };
    case ActionType.PROFILE_ADMIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ActionType.PROFILE_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case ActionType.PROFILE_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ActionType.PROFILE_ADMIN:
      return {
        ...state,
        loading: false,
        error: null,
        admin: {
          name: action.payload.name,
          email: action.payload.email,
          image: action.payload.image,
          role: action.payload.role,
          fcm_token: action.payload.fcm_token,
          flag: action.payload.flag,
        },
      };
    case ActionType.UPDATE_IMAGE_PROFILE:
      return {
        ...state,
        admin: {
          name: action.payload.name,
          email: action.payload.email,
          image: action.payload.image,
          flag: action.payload.flag,
        },
      };
    case ActionType.UPDATE_PROFILE:
      
      return {
        ...state,
        admin: action.payload,
        flag: action.payload.flag,
      };
    default:
      return state;
  }
};
